import { type FC, type PropsWithChildren } from 'react'

import { Box, type Colors, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  color: Colors
}

const Item: FC<PropsWithChildren<Props>> = ({ children, color }) => (
  <Box flexDirection="row" alignItems="center">
    <Icon.Medium icon="circle" color={color} />
    <Text.Normal size="100" color="grey800" weight="medium">
      {children}
    </Text.Normal>
  </Box>
)

export default Item
